"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initListItemIndexNow = exports.initStarToEndIndexes = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
var react_1 = __importStar(require("react"));
var ListItemIndexesForRenderingHandler_1 = __importDefault(require("./ListItemIndexesForRenderingHandler"));
exports.initStarToEndIndexes = [0, 20];
exports.initListItemIndexNow = 0;
var useDynamiceRenderList = function (list, selectedIndexFromProps) {
    var listLength = list.length;
    var listLastIndex = listLength - 1;
    var listPartRef = react_1.default.useRef(null);
    var listRefs = {
        current: list.map(function () { return (react_1.default.createRef()); })
    };
    var _a = react_1.useState(exports.initStarToEndIndexes), startToEndIndexesForRendering = _a[0], setIndexes = _a[1];
    var _b = react_1.useState(exports.initListItemIndexNow), listItemIndexNow = _b[0], setListItemIndexNow = _b[1];
    var handleUpdateStartToEndIndexes = function (indexNow, listLastIndex) {
        if (listRefs.current[0] && listRefs.current[0].current && listPartRef.current) {
            var listPart = listPartRef.current.getClientRects()[0];
            var firstListItem = listRefs.current[0].current.getClientRects()[0];
            var startToEndIndexesFromDOM = ListItemIndexesForRenderingHandler_1.default
                .getStartToEndIndexesFromDOM({
                indexNow: indexNow,
                listLastIndex: listLastIndex,
                firstListItem: firstListItem,
                listPart: listPart,
            });
            setIndexes(startToEndIndexesFromDOM);
        }
    };
    react_1.default.useEffect(function () {
        if (typeof selectedIndexFromProps === 'number') {
            setListItemIndexNow(selectedIndexFromProps);
        }
    }, [selectedIndexFromProps]);
    react_1.default.useEffect(function () {
        handleUpdateStartToEndIndexes(listItemIndexNow, listLastIndex);
    }, [listItemIndexNow, listLastIndex]);
    var handleScroll = react_1.useCallback(function () {
        if (listRefs.current[0] && listRefs.current[0].current && listPartRef.current) {
            var listPart = listPartRef.current.getClientRects()[0];
            var firstListItem = listRefs.current[0].current.getClientRects()[0];
            var specs = ListItemIndexesForRenderingHandler_1.default
                .getSpecs(firstListItem, listPart);
            var listItemIndexByScroll = specs.listItemIndexByScroll;
            setListItemIndexNow(listItemIndexByScroll);
        }
    }, [listRefs]);
    return ({
        listPartRef: listPartRef,
        listRefs: listRefs,
        startToEndIndexesForRendering: startToEndIndexesForRendering,
        listItemIndexNow: listItemIndexNow,
        setListItemIndexNow: setListItemIndexNow,
        handleScroll: handleScroll,
        handleUpdateStartToEndIndexes: handleUpdateStartToEndIndexes,
    });
};
exports.default = useDynamiceRenderList;
